import { Request } from '@/classes/Request.ts'
import { Util } from '@/modules/util'
import type { FamilyUserInvoice } from '@/types/familyUserInvoice'

// GET /ajax/invoices
export const familyUserInvoices = async () => {
  const response = await new Request().get('/ajax/invoices')
  return Util.Obj.keysToCamel(response.data.invoices) as FamilyUserInvoice[]
}
